import(/* webpackMode: "eager" */ "/Users/gbcimac08/Documents/GitHub/website-v1/src/app/tools/isa/page.tsx")